import React, { useEffect, useState } from "react";
import RaviImg from "../Assest/Ravindra Mahadik.png";
import AntImg from "../Assest/Anant yadav.png";
import UttamImg from "../Assest/Uttam Harne.png";

const leaders = [
  {
    name: "Ravindra Mahadik",
    position: "General Manager",
    image: RaviImg,
  },
  {
    name: "Anant Yadav",
    position: "General Manager",
    image: AntImg,
  },
  {
    name: "Uttam Harne",
    position: "Assistant General Manager",
    image: UttamImg,
  },
];

const MeetLeadership = () => {
  const [columns, setColumns] = useState(getColumns());
  const [hoveredIndex, setHoveredIndex] = useState(null);

  function getColumns() {
    const width = window.innerWidth;
    if (width < 640) return 1;       // Mobile
    if (width < 1024) return 2;      // Tablet
    return 3;                        // Desktop
  }

  useEffect(() => {
    const handleResize = () => setColumns(getColumns());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section style={{ backgroundColor: "#f8f8f8", padding: "48px 16px", textAlign: "center" }}>
      <h2 style={{ fontSize: "30px", fontWeight: "bold", marginBottom: "40px" }}>
        Meet the Leadership
      </h2>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: "32px",
          maxWidth: "1100px",
          margin: "0 auto",
        }}
      >
        {leaders.map((leader, index) => (
          <div
            key={index}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            style={{
              backgroundColor: "#f3f4f6",
              padding: "24px",
              borderRadius: "16px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              transform: hoveredIndex === index ? "scale(1.05)" : "scale(1)",
              transition: "transform 0.5s ease-in-out", // Slow zoom effect
            }}
          >
            <div
              style={{
                width: "128px",
                height: "128px",
                borderRadius: "50%",
                overflow: "hidden",
                margin: "0 auto 16px",
                border: "4px solid #4b5563",
              }}
            >
              <img
                src={leader.image}
                alt={leader.name}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </div>
            <h3 style={{ fontSize: "20px", fontWeight: "600", marginBottom: "4px" }}>
              {leader.name}
            </h3>
            <p style={{ color: "#6b7280" }}>{leader.position}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MeetLeadership;
